import { PropTypes } from "aem/ComponentWrapper";

export default {
  title: "Button",
  type: "rh/components/content/button",
  config: {
    emptyLabel: "Button",
    isEmpty: (_: PropTypes) => false
  }
};
